import { render, staticRenderFns } from "./seleccionSimple.vue?vue&type=template&id=07f9b07c&scoped=true"
import script from "./seleccionSimple.vue?vue&type=script&lang=js"
export * from "./seleccionSimple.vue?vue&type=script&lang=js"
import style0 from "./seleccionSimple.vue?vue&type=style&index=0&id=07f9b07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9b07c",
  null
  
)

export default component.exports